import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Date from '../Date/Date';

const HeaderMegaMenuMenuArticle = ({
  children,
  className,
  date,
  href,
  img,
  location,
  showMeta,
  targetBlank,
  type,
}) => <li className={`c-header-nav__item  c-header-article  ${className}`}>
    <Button
      color="none"
      href={href}
      className="c-header-nav__link  c-header-article__link"
      {...(targetBlank ? { target: '_blank' } : {})}
    >
      <div className="o-media  o-media--center">
        <div className="o-media__image">
          <div
            className="c-header-nav__image  c-header-article__image"
            style={{ backgroundImage: `url(${img})` }}
          />
        </div>
        <div className="o-media__body  u-text-bold">
          <span className="c-header-article__text">{children}</span>
          {showMeta && (
            <small className="c-header-article__meta">
              {type}
              {location} / <Date date={date} />
            </small>
          )}
        </div>
      </div>
    </Button>
  </li>

export default HeaderMegaMenuMenuArticle;

HeaderMegaMenuMenuArticle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  date: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  location: PropTypes.string,
  showMeta: PropTypes.bool,
  targetBlank: PropTypes.bool,
  type: PropTypes.oneOf([
    'Article',
    'Blog',
    'Case study',
    'Ebook',
    'Webinar',
    'Whitepaper',
  ]),
};

HeaderMegaMenuMenuArticle.defaultProps = {
  className: '',
  location: null,
  showMeta: false,
  targetBlank: false,
  type: null,
};
